function url(relativeUrl: string = ""): string {
    // @ts-ignore
    const baseUrl = global.CF.keformsUrl || "";

    return `${baseUrl}/${relativeUrl}`.replace(/([^:])\/{2,}/g, "$1/");
}

export type RequestParams = Record<string, string | undefined>;

function combineUrlWithParams(path: string, params: RequestParams): string {
    if (params === undefined) {
        return path;
    }
    const queryParts: string[] = [];
    for (const paramName of Object.keys(params)) {
        const paramValue = params[paramName];
        if (paramValue != undefined) {
            queryParts.push(`${paramName}=${encodeURIComponent(paramValue)}`);
        }
    }
    if (queryParts.length === 0) {
        return path;
    }
    return path + "?" + queryParts.join("&");
}

export function buildUrl(path: string, params: RequestParams): string {
    const urlWithParams = combineUrlWithParams(path, params);

    return url(urlWithParams);
}

export function buildPublicUrl(path: string, params: RequestParams): string {
    return buildUrl(`static/public/${path}`, params);
}

export function buildPublicScriptUrl(path: string, params: RequestParams): string {
    return buildPublicUrl(`scripts/${path}`, params);
}

export function buildPublicStyleUrl(path: string, params: RequestParams): string {
    return buildPublicUrl(`styles/${path}`, params);
}
